module.exports = __webpack_public_path__ + "img/8.395c6d03.jpg";